import { AppContent } from '../AppContent';

// FullSignatoryPage content for LBG
const switchToMobile: AppContent['switchToMobile'] = {
  switchToMobileContent: [
    {
      serviceName: 'Online for Business',
      header: 'Switch to a mobile device',
      content: 'Scan this QR code from your mobile device to switch:',
      previousLink: 'Previous',
      previousHref: '/switch-to-mobile',
    },
  ],
};

export default switchToMobile;
